export default __webpack_public_path__ + "static/media/rice.e249d2b4.png";